<ng-template #baseOverlayFormRef >
    <div class="container">
        <div>
            <h3>{{formHeader}}</h3>
            <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
                <div *ngFor="let field of formConfig">
    
                    <div class="row" *ngIf="field.type != 'textmsg'">
                        <div class="form-item" *ngIf="field.label">
                            <label [for]="field.name">{{ field.label }} <span class="text-danger" *ngIf="field.required">*</span></label>
                        </div>
                        <div class="input-container-box form-item">
                            <input [type]="field.type" *ngIf="field.type != 'textarea'" [placeholder]="field.placeholder? field.placeholder : ''" class="form-control" [ngClass]="{'disabled' : field.disabled != null && field.disabled != undefined}" [id]="field.name" [disabled]="field.disabled" [formControlName]="field.name" />
                            <textarea *ngIf="field.type == 'textarea'" [placeholder]="field.placeholder? field.placeholder : ''" class="form-control" [ngClass]="{'disabled' : field.disabled != null && field.disabled != undefined}" [id]="field.name" [disabled]="field.disabled" [formControlName]="field.name" ></textarea>
                        </div>
                        <div class="form-item text-danger" *ngIf="myForm.controls[field.name].touched && myForm.controls[field.name].errors && myForm.controls[field.name].errors.required" >
                            {{field.label}} is required
                        </div>
                    </div>
                    <div *ngIf="field.type == 'textmsg'" class="form-item text-msg">
                        {{field.msg}} <span *ngIf="field.value" class="text-ellipsis">{{field.value}}</span>
                    </div>        
                </div>
                <div *ngIf="error" class="row text-danger">{{error}}</div>
            </form>
        </div>
        <div class="row-buttons">
            <button class="btn btn-cancel" (click)="cancel()">Close</button>
            <button class="btn btn-submit" (click)="onSubmit()" [disabled]="!myForm.valid || !myForm.dirty">Save</button>          
        </div>
    </div>  
</ng-template>